import {
  Box,
  Divider,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Spinner,
  Text,
} from '@chakra-ui/react'

import { Search } from '../../components/icons/icons'

interface SelectAsInputProps {
  isDisabled?: boolean
  h?: string
  w?: string
  value: { id: string; name: string; avatar: string } | null
  onChange: (v: { id: string; name: string; avatar: string } | null) => void
  search: string
  onSearchChange: (v: string) => void
  options: { id: string; name: string }[]
  isLoading?: boolean
  placeholder: string
  singular?: boolean
}

const SelectAsInput = ({
  isDisabled,
  value,
  onChange,
  search,
  onSearchChange,
  options,
  isLoading,
  placeholder,
  h,
  w,
  singular,
}: SelectAsInputProps) => {
  // if(value) return <InputGroup>
  //     <Input value={value.name} w={w ?? '200px'} h={h ?? undefined}
  //         readOnly
  //         onFocus={() => onChange(null)}
  //     />
  // </InputGroup>

  return (
    <Box position="relative">
      <InputGroup mb="10px">
        <InputLeftElement>
          <Icon width="18" height="18" viewBox="0 0 18 18">
            <Search color="#7E8B9A" />
          </Icon>
        </InputLeftElement>
        <Input
          isDisabled={isDisabled}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          h={h ?? undefined}
          placeholder={placeholder}
          w={w ?? '200px'}
          variant="filled"
        />
        {isLoading && (
          <InputRightElement>
            <Spinner color="#7E8B9A" size="xs" />
          </InputRightElement>
        )}
      </InputGroup>

      {search.length > 1 && search != value?.name && !isLoading && !isDisabled && (
        <Box
          w="100%"
          pos="absolute"
          zIndex="1"
          top="50px"
          overflow="hidden"
          pb="4px"
          pt="4px"
          bg="white"
          boxShadow="0px 6px 35px 5px #0000001F"
          borderColor="neutral.100"
          borderWidth="1px"
          borderRadius="8px"
        >
          {options.length === 0 && (
            <Flex h="42px" p="2px 16px" alignItems="center">
              <Text w="100%" textAlign={'center'} textStyle="b-sm" color="neutral.500">
                No results found
              </Text>
            </Flex>
          )}
          {options.map((option: any, i: number) => {
            return (
              <>
                <Flex
                  key={i}
                  h="28px"
                  p="2px 16px"
                  cursor="pointer"
                  alignItems="center"
                  _hover={{ bg: 'neutral.50' }}
                  transition="0.2s ease-out"
                  onClick={() => {
                    onChange(option)
                    if (!singular) onSearchChange('')
                    else onSearchChange(option.name)
                  }}
                >
                  <Text textStyle="b-sm" color="neutral.900">
                    {option.name}
                  </Text>
                </Flex>
                {i !== options.length - 1 && <Divider />}
              </>
            )
          })}
        </Box>
      )}
    </Box>
  )
}

export default SelectAsInput
